var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCroseGreyCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM4.82427 3.97573C4.58995 3.74142 4.21005 3.74142 3.97574 3.97573C3.74142 4.21005 3.74142 4.58995 3.97574 4.82426L5.15147 6L3.97574 7.17573C3.74142 7.41005 3.74142 7.78995 3.97574 8.02426C4.21005 8.25858 4.58995 8.25858 4.82427 8.02426L6 6.84853L7.17574 8.02426C7.41005 8.25858 7.78995 8.25858 8.02427 8.02426C8.25858 7.78995 8.25858 7.41005 8.02427 7.17573L6.84853 6L8.02427 4.82426C8.25858 4.58995 8.25858 4.21005 8.02427 3.97573C7.78995 3.74142 7.41005 3.74142 7.17574 3.97573L6 5.15147L4.82427 3.97573Z",
    fill: "#CDCDCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroseGreyCircleIcon);
export default __webpack_public_path__ + "static/media/crose-grey-circle-icon.2ae92fc07b40ea93d30bfb581ec3effa.svg";
export { ForwardRef as ReactComponent };